<template>
  <template v-if="props.data">
    <div
      v-if="props.data.length"
      class="flex -mx-2 overflow-x-auto pb-2"
    >
      <div
        v-for="item, i in props.data"
        :key="`project_${i}`"
        class="px-2 w-1/2 md:w-1/3 flex-[0_0_50%] md:flex-[0_0_33%]"
      >
        <Card 
          :pt="{
            content: 'p-0'
          }"
        >
          <template #content>
            <div
              class="relative overflow-hidden pb-[60%]"
            >
              <nuxt-picture
                preload
                :img-attrs="{class: 'absolute inset-0 w-full h-full object-cover', alt: item.name}"
                :src="item.image ? item.image : '/img/missing.png'"
                :placeholder="[100, 50, 10]"
                sizes=""
              />
            </div>

            <div class="p-2">
              <div
                class="leading-[120%] text-[12px] h-[30px]"
              >
                {{ item.name }}
              </div>

              <div class="mt-2 text-right">
                <div>
                  <span class="text-[12px] font-medium">{{ moneyFormat(item.total) }}</span>
                </div>
                <div class="text-[10px] text-nowrap">
                  {{ $t('shippingAndTaxes') }}
                </div>
              </div>
            </div>
          </template>
        </Card>
      </div>
    </div>

    <Message
      v-else
      severity="info"
    >
      {{ $t('giftsIsEmpty') }}
    </Message>
  </template>

  <div
    v-else
    class="flex -mx-2 overflow-x-auto"
  >
    <div
      v-for="n in 3"
      :key="n"
      class="px-2 w-1/3 flex-[1_0_33%]"
    >
      <Skeleton
        class="!w-full !h-[8rem]"
      >
      </Skeleton>
    </div>
  </div>
</template>
<script setup>
/**
* Props
*/
const props = defineProps({
  data: {
    type: [Array],
    default: null
  }
})
</script>